/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OptimizeTransportLot200ResponseMovedItemsInner } from './OptimizeTransportLot200ResponseMovedItemsInner';
import {
    OptimizeTransportLot200ResponseMovedItemsInnerFromJSON,
    OptimizeTransportLot200ResponseMovedItemsInnerFromJSONTyped,
    OptimizeTransportLot200ResponseMovedItemsInnerToJSON,
} from './OptimizeTransportLot200ResponseMovedItemsInner';
import type { OptimizeTransportLotRequestTodayStockListInner } from './OptimizeTransportLotRequestTodayStockListInner';
import {
    OptimizeTransportLotRequestTodayStockListInnerFromJSON,
    OptimizeTransportLotRequestTodayStockListInnerFromJSONTyped,
    OptimizeTransportLotRequestTodayStockListInnerToJSON,
} from './OptimizeTransportLotRequestTodayStockListInner';
import type { TransportLotPlan } from './TransportLotPlan';
import {
    TransportLotPlanFromJSON,
    TransportLotPlanFromJSONTyped,
    TransportLotPlanToJSON,
} from './TransportLotPlan';

/**
 * 
 * @export
 * @interface OptimizeTransportLot200Response
 */
export interface OptimizeTransportLot200Response {
    /**
     * 
     * @type {Array<OptimizeTransportLot200ResponseMovedItemsInner>}
     * @memberof OptimizeTransportLot200Response
     */
    movedItems: Array<OptimizeTransportLot200ResponseMovedItemsInner>;
    /**
     * 
     * @type {Array<TransportLotPlan>}
     * @memberof OptimizeTransportLot200Response
     */
    todayTransportLotList: Array<TransportLotPlan>;
    /**
     * 
     * @type {Array<TransportLotPlan>}
     * @memberof OptimizeTransportLot200Response
     */
    nextdayTransportLotList: Array<TransportLotPlan>;
    /**
     * 
     * @type {Array<OptimizeTransportLotRequestTodayStockListInner>}
     * @memberof OptimizeTransportLot200Response
     */
    todayStockList: Array<OptimizeTransportLotRequestTodayStockListInner>;
    /**
     * 
     * @type {Array<OptimizeTransportLotRequestTodayStockListInner>}
     * @memberof OptimizeTransportLot200Response
     */
    nextdayStockList: Array<OptimizeTransportLotRequestTodayStockListInner>;
}

/**
 * Check if a given object implements the OptimizeTransportLot200Response interface.
 */
export function instanceOfOptimizeTransportLot200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "movedItems" in value;
    isInstance = isInstance && "todayTransportLotList" in value;
    isInstance = isInstance && "nextdayTransportLotList" in value;
    isInstance = isInstance && "todayStockList" in value;
    isInstance = isInstance && "nextdayStockList" in value;

    return isInstance;
}

export function OptimizeTransportLot200ResponseFromJSON(json: any): OptimizeTransportLot200Response {
    return OptimizeTransportLot200ResponseFromJSONTyped(json, false);
}

export function OptimizeTransportLot200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizeTransportLot200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'movedItems': ((json['moved_items'] as Array<any>).map(OptimizeTransportLot200ResponseMovedItemsInnerFromJSON)),
        'todayTransportLotList': ((json['today_transportLotList'] as Array<any>).map(TransportLotPlanFromJSON)),
        'nextdayTransportLotList': ((json['nextday_transportLotList'] as Array<any>).map(TransportLotPlanFromJSON)),
        'todayStockList': ((json['today_stockList'] as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerFromJSON)),
        'nextdayStockList': ((json['nextday_stockList'] as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerFromJSON)),
    };
}

export function OptimizeTransportLot200ResponseToJSON(value?: OptimizeTransportLot200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'moved_items': ((value.movedItems as Array<any>).map(OptimizeTransportLot200ResponseMovedItemsInnerToJSON)),
        'today_transportLotList': ((value.todayTransportLotList as Array<any>).map(TransportLotPlanToJSON)),
        'nextday_transportLotList': ((value.nextdayTransportLotList as Array<any>).map(TransportLotPlanToJSON)),
        'today_stockList': ((value.todayStockList as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerToJSON)),
        'nextday_stockList': ((value.nextdayStockList as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerToJSON)),
    };
}

